module.exports = __webpack_public_path__ + "img/background-platinum-large.7329d4c1.svg";